module.exports = __webpack_public_path__ + "static/durazno6-58a0543e07042b7073873b4ee3a8f0c9.jpg";